export const RGPD = '/rgpd';
